<template>
    <article class="profile-edit-component__subsection" :data-testid="props.dataTestid">
        <header v-if="hasSlotHeader" :data-testid="dataTestidTitle" class="profile-edit-component__subsection__header">
            <slot name="sub-header" />
        </header>
        <div :data-testid="dataTestidBody" class="profile-edit-component__subsection__body">
            <slot name="sub-body" />
        </div>
    </article>
</template>
<script setup lang="ts">
    import {useSlots, computed} from 'vue';

    const props = defineProps<{
        dataTestid: string;
    }>();

    const slots = useSlots();
    const hasSlotHeader = Object.prototype.hasOwnProperty.call(slots, 'sub-header');

    const dataTestidTitle = computed(() => `${props.dataTestid}-header`);
    const dataTestidBody = computed(() => `${props.dataTestid}-body`);
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .profile-edit-component {
        &__subsection {
            margin-bottom: var(--joy-core-spacing-8);

            &__header {
                margin-bottom: var(--joy-core-spacing-4);
                @include text.getFontBySize(primary-450);
                color: var(--joy-color-neutral-70);
            }
            &__body {
                @include text.getFontBySize(primary-400);
            }
        }
    }
</style>
